<template>
  <v-col cols="12">
    <v-row align="end">
      <v-col cols="12" sm="6" md="3">
        <datePicker
          v-model="filtros.fechaInicio"
          format="YYYY-MM-DD"
          label="Desde (Obligatorio)"
          clearable
          maxToday
          :disabled="loadingReporte"
        />
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <datePicker
          v-model="filtros.fechaFin"
          :minDate="filtros.fechaInicio"
          format="YYYY-MM-DD"
          label="Hasta (Obligatorio)"
          clearable
          maxToday
          :disabled="loadingReporte"
        />
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          v-model="filtros.idsEquipoPredefinido"
          :items="equiposPredefinidos"
          item-value="idEquipoPredefinido"
          item-text="nombre"
          label="Equipo(s) (Opcional)"
          multiple
          chips
          clearable
          hide-details
          :loading="loadingEquipos"
          :disabled="loadingReporte"
        >
          <template v-slot:selection="{ index }">
            <v-chip v-if="index === 0" small>
              {{ filtros.idsEquipoPredefinido.length }} equipos
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          v-model="filtros.idsLider"
          :items="lideres"
          :item-text="nombrePersona"
          item-value="idPersona"
          label="Líder(es) (Opcional)"
          multiple
          chips
          clearable
          hide-details
          :loading="loadingLideres"
          :disabled="loadingReporte"
        >
          <template v-slot:selection="{ index }">
            <v-chip v-if="index === 0" small>
              {{ filtros.idsLider.length }} líderes
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12" class="d-flex justify-end">
        <v-btn
          color="primary"
          :loading="loadingReporte"
          :disabled="!filtrosValidos"
          @click="consultarReporte"
        >
          Consultar
        </v-btn>
      </v-col>
    </v-row>

    <v-alert
      v-if="mensaje"
      class="mt-3"
      :type="errorReporte ? 'error' : 'success'"
      dense
      text
    >
      {{ mensaje }}
    </v-alert>

    <v-row v-if="hayDatosGrafica" class="mt-4">
      <v-col cols="12">
        <apexchart
          type="bar"
          height="350"
          :options="opeChartOptions"
          :series="opeChartSeries"
        ></apexchart>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      filtros: {
        fechaInicio: null,
        fechaFin: null,
        idsEquipoPredefinido: [],
        idsLider: [],
      },
      equiposPredefinidos: [],
      lideres: [],
      reporte: null,
      loadingReporte: false,
      loadingEquipos: false,
      loadingLideres: false,
      errorReporte: false,
      mensaje: "",
    };
  },
  computed: {
    filtrosValidos() {
      const inicio = moment(this.filtros.fechaInicio, "YYYY-MM-DD", true);
      const fin = moment(this.filtros.fechaFin, "YYYY-MM-DD", true);

      return inicio.isValid() && fin.isValid() && inicio.isSameOrBefore(fin);
    },
    reporteLideres() {
      return this.reporte && Array.isArray(this.reporte.lideres)
        ? this.reporte.lideres
        : [];
    },
    hayDatosGrafica() {
      return this.reporteLideres.length > 0;
    },
    opeChartSeries() {
      return [
        {
          name: "OPE promedio ponderado",
          data: this.reporteLideres.map(item => Number(item.opePromedioPonderado) || 0),
        },
      ];
    },
    opeChartOptions() {
      return {
        chart: {
          toolbar: {
            show: true,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: value => `${Number(value).toFixed(2)}%`,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            columnWidth: "45%",
          },
        },
        xaxis: {
          categories: this.reporteLideres.map(item => item.equipoPredefinido || "Sin equipo"),
          title: {
            text: "Equipo predefinido",
          },
        },
        yaxis: {
          min: 0,
          title: {
            text: "OPE promedio ponderado",
          },
          labels: {
            formatter: value => `${Number(value).toFixed(2)}%`,
          },
        },
        tooltip: {
          y: {
            formatter: value => `${Number(value).toFixed(2)}%`,
          },
        },
      };
    },
  },
  mounted() {
    this.getEquiposPredefinidos();
    this.getLideres();
  },
  methods: {
    nombrePersona(persona) {
      if (!persona) return "";

      const nombre = persona.nombre || persona.Nombre || "";
      const paterno = persona.paterno || persona.Paterno || "";
      const materno = persona.materno || persona.Materno || "";

      return `${nombre} ${paterno} ${materno}`.replace(/\s+/g, " ").trim();
    },
    getEquiposPredefinidos() {
      this.loadingEquipos = true;

      axios
        .get("/EquipoPredefinidos")
        .then(response => {
          this.equiposPredefinidos = Array.isArray(response.data) ? response.data : [];
          //console.log("hola");
        })
        .catch(error => {
          console.log(error);
          this.equiposPredefinidos = [];
        })
        .finally(() => {
          this.loadingEquipos = false;
        });
    },
    getLideres() {
      this.loadingLideres = true;

      axios
        .get("/Personas")
        .then(response => {
          const personas = Array.isArray(response.data) ? response.data : [];
          this.lideres = personas.filter(persona => (persona.idPuesto || persona.IdPuesto) == 6);
        })
        .catch(error => {
          console.log(error);
          this.lideres = [];
        })
        .finally(() => {
          this.loadingLideres = false;
        });
    },
    crearParamsReporte() {
      const params = new URLSearchParams();

      params.append("fechaInicio", this.filtros.fechaInicio);
      params.append("fechaFin", this.filtros.fechaFin);

      this.filtros.idsEquipoPredefinido.forEach(id => {
        params.append("idEquipoPredefinido", String(id));
      });

      this.filtros.idsLider.forEach(id => {
        params.append("idLider", String(id));
      });

      return params;
    },
    consultarReporte() {
      if (!this.filtrosValidos) return;

      this.loadingReporte = true;
      this.errorReporte = false;
      this.mensaje = "";

      const params = this.crearParamsReporte();

      axios
        .get(`/OPE/ReporteOpeLideresEquipos?${params.toString()}`)
        .then(response => {
          this.reporte = response.data;
          this.mensaje = "Reporte consultado correctamente.";
        })
        .catch(error => {
          console.log(error);
          this.reporte = null;
          this.errorReporte = true;
          this.mensaje = "No se pudo consultar el reporte.";
        })
        .finally(() => {
          this.loadingReporte = false;
        });
    },
  },
};
</script>